<template>
  <div class="h-100 position-absolute root w-100">
    <div class="align-items-center bg-dark bg-opacity-50 d-none fixed-top h-100 justify-content-center loading w-100" ref="loading">
      <Pulse-Loader :loading="loading"></Pulse-Loader>
    </div>

    <b-modal
      :centered="tutorialModal.centered"
      :noCloseOnBackdrop="tutorialModal.noCloseOnBackdrop"
      :size="tutorialModal.size"
      :title="tutorialModal.title"

      hide-footer
      v-model="changeTutorialModal"
    >
      <div class="align-items-center d-flex justify-content-center">
        <img class="col-12 col-md-10" src="img/tutorial.gif">
      </div>
    </b-modal>

    <div class="align-items-center d-flex justify-content-center h-100">
      <div class="justify-content-center row w-100">
        <div class="col-10 col-lg-5 col-md-7 col-xl-3 fadeInDown m-auto p-0 py-5 rounded-3 shadow-lg">
          <div class="fadeIn first mt-4">
            <img alt="Laborat&oacute;rio" class="mb-4 w-50" src="assets/logo.png"/>
          </div>

          <form @submit.prevent="login">
            <select
              class="border-2 mb-2 p-3 rounded-1 shadow-0 shadow-none text-center userTypeInput"
              ref="userType"
              required
              role="button"
              v-model="userType"
              @change="changeUserType($event)"
            >
              <option disabled value="">
                Tipo de usu&aacute;rio
              </option>
              <option value="tulPaciente">
                Paciente
              </option>
              <option value="tulApoio">
                Apoio
              </option>
              <option value="tulMedico">
                M&eacute;dico
              </option>
              <option value="tulConveniado">
                Conveniado
              </option>
              <option value="tulCliente">
                Cliente
              </option>
              <option value="tulCentralAtendimento">
                Central de atendimento
              </option>
              <!--
              <option value="tulValidacaoDigital">
                Valida&ccedil;&atilde;o digital
              </option>
              -->
            </select>

            <input
              class="border border-2 fadeIn m-0 mb-2 p-3 rounded-2 second text-center"
              id="login"
              name="login"
              placeholder="Nº do laudo ou usuário"
              ref="username"
              type="text"
              v-model="username"
            />

            <input
              class="border border-2 fadeIn m-0 mb-2 p-3 rounded-2 text-center third"
              id="password"
              name="password"
              placeholder="Senha"
              ref="password"
              type="password"
              v-model="password"
            />

            <input
              class="border border-2 d-none m-0 mb-2 p-3 rounded-2 text-center"
              id="hash"
              name="hash"
              placeholder="Hash de validação"
              ref="hash"
              type="text"
              v-model="hash"
            />

            <input
              class="border-0 fadeIn fourth m-0 mb-3 p-3 rounded-2 text-uppercase text-white"
              ref="acessar"
              type="submit"
              value="Acessar"
            />

            <div class="d-none" ref="tutorial">
              <p class="m-0">
                D&uacute;vidas de como acessar?
              </p>
              <p class="m-0">
                Ent&atilde;o <span class="span-link" role="button" @click="showChangeTutorialModal" >clique aqui</span>
              </p>
            </div>
          </form>
          <div class="col-12 d-block fadeIn fifth mt-3 text-center">
            <small>
              {{ this.$version }}
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { BModal } from "bootstrap-vue";
  import PulseLoader from "vue-spinner/src/PulseLoader.vue";

  export default {
    name: "Login",
    components: {
      bmodal: BModal,
      PulseLoader,
    },
    data: () => {
      return {
        changeTutorialModal: false,
        loading: false,
        hash: "",
        password: "",
        username: "",
        userType: "",
        version: "",
        tutorialModal: {
          centered: true,
          noCloseOnBackdrop: true,
          size: "lg",
          title: "Tutorial de acesso",
      },
      };
    },
    computed: {
      acoes() {
        return this.$actions;
      },
      state() {
        return this.$store.state;
      },
    },
    methods: {
      showChangeTutorialModal() {
      let _this = this;
      _this.changeTutorialModal = true;
      _this.version = _this.$version;
    },
      async login(e) {
        e.preventDefault();

        let _this = this;

        var tpLogin = _this.$refs.userType.value;

        if (tpLogin === "tulValidacaoDigital") {
          var hash = _this.$refs.hash.value;

          if (hash) {
            // Apply hash validation logic
          } else {
            _this.$notify({
              group: "alerts",
              text: "A Hash de validação digital não foi informada",
              title: "Atenção!",
              type: "error"
            });
          }
        } else {
          var password = _this.$refs.password.value;
          var username = _this.$refs.username.value;

          if (password && tpLogin && username) {
            if (tpLogin == "tulPaciente") {
              if (!(username.includes('/'))) {
                tpLogin = "tulPacienteCpf";
              }
            }

            _this.showLoading();

            if (_this.$signedOnly !== "true") {
              await axios
              .post(
                "v1/login" +
                "?username=" +
                username +
                "&password=" +
                password +
                "&tplogin=" +
                tpLogin
              )
              .then(function (response) {
                if (response.status === 201) {
                  const { token } = response.data;

                  _this.acoes.setFilial(_this.state, response.data.idd);
                  _this.acoes.setLoginType(_this.state, tpLogin);
                  _this.acoes.setPassword(_this.state, password);
                  _this.acoes.setToken(_this.state, token);
                  _this.acoes.setUser(_this.state, username);
                  _this.acoes.setUserID(_this.state, response.data.id);
                  _this.acoes.setUserType(_this.state, tpLogin);

                  if (tpLogin === 'tulPaciente') {
                    _this.$router.push('/list');
                  } else {
                    _this.$router.push('/filter');
                  }
                }
              })
              .catch(() => {
                _this.$notify({
                  group: "alerts",
                  text: "Usuário ou senha incorretos",
                  title: "Atenção!",
                  type: "error",
                });
              }).finally(() => {
                _this.hideLoading();
              });
            } else {
              await axios
              .post(
                "v2/login" +
                "?COD100=" +
                password +
                "&COD101=" +
                username +
                "&COD106=" +
                tpLogin
              )
              .then(function (response) {
                if (response.status === 201) {
                  const { token } = response.data;

                  _this.acoes.setFilial(_this.state, response.data.idd);
                  _this.acoes.setLoginType(_this.state, tpLogin);
                  _this.acoes.setPassword(_this.state, password);
                  _this.acoes.setToken(_this.state, token);
                  _this.acoes.setUser(_this.state, username);
                  _this.acoes.setUserID(_this.state, response.data.id);
                  _this.acoes.setUserType(_this.state, tpLogin);

                  if (tpLogin === 'tulPaciente') {
                    _this.$router.push('/list');
                  } else {
                    _this.$router.push('/filter');
                  }
                }
              })
              .catch(() => {
                _this.$notify({
                  group: "alerts",
                  text: "Usuário ou senha incorretos",
                  title: "Atenção!",
                  type: "error",
                });
              }).finally(() => {
                _this.hideLoading();
              });
            }
          } else {
            _this.$notify({
              group: "alerts",
              text: "Os dados não foram informados corretamente",
              title: "Atenção!",
              type: "error"
            });
          }
        }
      },
      changeUserType(event) {
        let _this = this;
        let val = event.target.value;

        if (val === 'tulValidacaoDigital') {
          _this.$refs.password.classList.add("d-none");
          _this.$refs.username.classList.add("d-none");
          _this.$refs.hash.classList.remove("d-none");
        } else {
          _this.$refs.hash.classList.add("d-none");
          _this.$refs.username.classList.remove("d-none", "fadeIn");
          _this.$refs.password.classList.remove("d-none", "fadeIn");
          
          if (val === 'tulPaciente') {
            _this.$refs.tutorial.classList.remove("d-none");
            _this.$refs.username.placeholder = 'N° do laudo / CPF';
          } else {
            _this.$refs.tutorial.classList.add("d-none");
            _this.$refs.username.placeholder = 'Usuário';
          }
        }
      },
      hideLoading() {
        let _this = this;

        _this.loading = false;
        _this.$refs.loading.classList.add("d-none");
        _this.$refs.loading.classList.remove("d-flex");
      },
      showLoading() {
        let _this = this;

        _this.loading = true;
        _this.$refs.loading.classList.add("d-flex");
        _this.$refs.loading.classList.remove("d-none");
      }
    },
  };
</script>

<style scoped></style>